import React from 'react';

import { LearningLeaderboardStyleProps } from '../../types';

export const LearningLeaderboardStyle: React.FC<LearningLeaderboardStyleProps> = () => {
    return <div />;
};
